import { gql } from '@apollo/client';

export const ATHLETE_HANDLE_COUNTER_OFFER = gql`
  mutation AthleteHandleCounterOffer($input: HandleCounterOfferInput!) {
    athleteHandleCounterOffer(input: $input) {
      id
    }
  }
`;

export const BRAND_HANDLE_COUNTER_OFFER = gql`
  mutation BrandHandleCounterOffer($input: HandleCounterOfferInput!) {
    brandHandleCounterOffer(input: $input) {
      id
    }
  }
`;
